import {useState, useEffect} from "react";

const AppHeader = (prorps) => {
    const titleArr = () => {
        let titleArrStr = "";
        prorps.headerArr.forEach((item, idx) => {
            if (idx !== prorps.headerArr.length - 1) {
                titleArrStr += item + "/";
            } else {
                titleArrStr += item;
            }
        });
        return titleArrStr;
    };
    useEffect(() => {}, []);
    return (
        <>
            <div className="app_header">
                <h1>{titleArr()}</h1>
            </div>
        </>
    );
};
export default AppHeader;
